module.exports = __webpack_public_path__ + "img/potencia_b_red.7ab9c930.svg";